import { Rout_create } from './Rout.create'
import { Rout_to } from './Rout'

export interface Rout_PlannerRoutesArgs {
    PlannerApp: React.FunctionComponent<unknown>
}

export const Rout_PlannerRoutes = (args: Rout_PlannerRoutesArgs) => [
    /* duplicate for legacy routing */
    Rout_create('/planner(/:page)(/:locationId)', args.PlannerApp),
]

export function Rout_toSchedulerLocation(locationId: number) {
    Rout_to(`/planner/viewLocationSchedule/${locationId}`)
}

export function Rout_toSchedulerSearch() {
    Rout_to(`/planner/viewSchedule`)
}

export function Rout_toCalendar() {
    Rout_to(`/planner/calendar`)
}

export function Rout_toRoutePlanner() {
    Rout_to(`/planner/route`)
}

export function Rout_toPlannerSelect() {
    Rout_to(`/planner/select`)
}

export function Rout_toPlanner() {
    Rout_to(`/planner`)
}
